import { z } from 'zod';

export enum DefectNoticeAffectedArea {
  APARTMENT = 'apartment',
  PUBLIC_SPACES = 'public-spaces',
  COURTYARD = 'courtyard',
}

export enum DefectNoticeClass {
  HVAC = 'hvac',
  ELECTRICAL = 'electrical',
  LOCKS = 'locks',
  REPAIR = 'repair',
  OTHER = 'other',
}

export const defectNoticeSchema = z.object({
  title: z.string().min(1),
  affectedArea: z.nativeEnum(DefectNoticeAffectedArea),
  defectClass: z.nativeEnum(DefectNoticeClass),
  description: z.string().min(1),
  masterKeyAccessAllowed: z.boolean(),
  hasPetsInApartment: z.boolean(),
  petsDescription: z.string().optional(),
  attachments: z.custom<FileList>(),
});

export type DefectNotice = z.infer<typeof defectNoticeSchema>;
